"use strict";

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

__export(require("./root.epic"));

var setupEpicDependencies_1 = require("./setupEpicDependencies");

exports.setupEpicDependencies = setupEpicDependencies_1.setupEpicDependencies;